/**
 * DÉCROCHE — comportements front (aucune dépendance externe)
 * - FAQ accordéons
 * - CTA sticky mobile après scroll
 * - Wizard de candidature (4 étapes) -> ajout panier via Ajax Cart API
 *
 * IMPORTANT (voir README-DECROCHE.md section "Upload CV") :
 * L'upload du CV n'est PAS géré ici. Il est délégué au bloc d'app
 * "Upload Native" (ou équivalent Shopify App Store) inséré dans la
 * section decroche-application-form via un app block ({% content_for "blocks" %}).
 * Cette app écrit l'URL du fichier Shopify dans un champ caché
 * #DcCvFileUrl (voir data-dc-cv-url-target). Tant que l'app n'est pas
 * installée, un <input type="file"> de secours encode le PDF en état
 * "en attente d'upload" et bloque le paiement avec un message clair —
 * pour ne jamais faire croire qu'un CV a été transmis alors qu'il ne l'a pas été.
 *
 * Ce fichier est inclus par plusieurs sections indépendantes (plusieurs
 * peuvent apparaître sur la même page, ex. la page d'accueil). Le garde
 * ci-dessous évite que le script ne s'exécute plusieurs fois sur une même
 * page (double listeners, double tracking landing_view, etc.).
 */
if (!window.__dcJsLoaded) {
window.__dcJsLoaded = true;
(function () {
  "use strict";

  /* ---------------- Analytics helper (Décroche events, section 22) ---------------- */
  function dcTrack(name, data) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, data || {}));
      document.dispatchEvent(new CustomEvent("decroche:" + name, { detail: data || {} }));
    } catch (e) { /* noop */ }
  }
  window.dcTrack = dcTrack;

  document.addEventListener("DOMContentLoaded", function () {
    dcTrack("landing_view", { path: window.location.pathname });
  });

  /* ---------------- FAQ ---------------- */
  document.querySelectorAll(".dc-faq__item").forEach(function (item) {
    item.addEventListener("toggle", function () {
      if (item.open) {
        document.querySelectorAll(".dc-faq__item[open]").forEach(function (other) {
          if (other !== item) other.removeAttribute("open");
        });
      }
    });
  });

  /* ---------------- Sticky mobile CTA ---------------- */
  var stickyCta = document.querySelector("[data-dc-sticky-cta]");
  if (stickyCta) {
    var showAfter = 480;
    var onScroll = function () {
      if (window.scrollY > showAfter) {
        stickyCta.classList.add("is-visible");
      } else {
        stickyCta.classList.remove("is-visible");
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* ---------------- Wizard ---------------- */
  var form = document.querySelector("[data-dc-wizard]");
  if (!form) return;

  var steps = Array.prototype.slice.call(form.querySelectorAll("[data-dc-step]"));
  var totalSteps = steps.length;
  var currentStep = 0;
  var progressFill = form.querySelector("[data-dc-progress-fill]");
  var progressLabel = form.querySelector("[data-dc-progress-label]");
  var variantId = form.getAttribute("data-dc-variant-id");
  var cartAddUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
    ? window.Shopify.routes.root
    : "/") + "cart/add.js";
  var cartUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
    ? window.Shopify.routes.root
    : "/") + "cart";

  var stepEventNames = ["job_added", "cv_uploaded", "application_form_completed", "application_form_completed"];

  function showStep(index) {
    steps.forEach(function (el, i) {
      el.classList.toggle("is-active", i === index);
    });
    var pct = Math.round(((index + 1) / totalSteps) * 100);
    if (progressFill) progressFill.style.width = pct + "%";
    if (progressLabel) progressLabel.textContent = (index + 1) + " / " + totalSteps;
    form.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function fieldsInStep(index) {
    return Array.prototype.slice.call(steps[index].querySelectorAll("[data-dc-required]"));
  }

  function setError(field, message) {
    var wrap = field.closest(".dc-field") || field.parentElement;
    wrap.classList.add("dc-field--error");
    var err = wrap.querySelector(".dc-error");
    if (err) {
      err.textContent = message;
      err.classList.add("dc-error--visible");
    }
  }

  function clearError(field) {
    var wrap = field.closest(".dc-field") || field.parentElement;
    wrap.classList.remove("dc-field--error");
    var err = wrap.querySelector(".dc-error");
    if (err) err.classList.remove("dc-error--visible");
  }

  function validateStep(index) {
    var valid = true;
    fieldsInStep(index).forEach(function (field) {
      clearError(field);
      var value = (field.value || "").trim();
      if (field.type === "radio") {
        var groupName = field.name;
        var checked = steps[index].querySelector('input[name="' + groupName + '"]:checked');
        if (!checked) {
          valid = false;
          setError(field, "Merci de faire un choix.");
        }
        return;
      }
      if (field.type === "checkbox") {
        if (!field.checked) {
          valid = false;
          setError(field, "Ce champ est requis.");
        }
        return;
      }
      if (!value) {
        valid = false;
        setError(field, "Ce champ est requis.");
      } else if (field.type === "email" && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        valid = false;
        setError(field, "Merci d'indiquer un email valide.");
      }
    });

    // Étape 1 : au moins l'URL OU le texte de l'annonce doit être renseigné.
    if (index === 0) {
      var jobUrl = form.querySelector('[name="properties[job_url]"]');
      var jobDesc = form.querySelector('[name="properties[job_description]"]');
      if (jobUrl && jobDesc && !jobUrl.value.trim() && !jobDesc.value.trim()) {
        valid = false;
        setError(jobDesc, "Colle l'URL de l'offre ci-dessus, ou son contenu ici.");
      }
    }

    // Étape 2 : CV requis, via l'app d'upload (input caché) ou fallback fichier.
    if (index === 1) {
      var cvUrlInput = form.querySelector("[data-dc-cv-url-target]");
      var cvFallback = form.querySelector("[data-dc-cv-fallback]");
      var hasAppUpload = cvUrlInput && cvUrlInput.value.trim();
      var hasFallback = cvFallback && cvFallback.files && cvFallback.files.length > 0;
      if (!hasAppUpload && !hasFallback) {
        valid = false;
        var uploadBox = form.querySelector("[data-dc-upload-box]");
        if (uploadBox) {
          var err = uploadBox.querySelector(".dc-error");
          if (err) { err.textContent = "Dépose ton CV (PDF de préférence) pour continuer."; err.classList.add("dc-error--visible"); }
        }
      }
    }

    return valid;
  }

  form.querySelectorAll("[data-dc-next]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (!validateStep(currentStep)) return;
      dcTrack(stepEventNames[currentStep] || "step_completed", { step: currentStep + 1 });
      if (currentStep === totalSteps - 2) {
        fillRecap();
      }
      currentStep = Math.min(currentStep + 1, totalSteps - 1);
      showStep(currentStep);
    });
  });

  form.querySelectorAll("[data-dc-prev]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      currentStep = Math.max(currentStep - 1, 0);
      showStep(currentStep);
    });
  });

  function fillRecap() {
    var map = {
      "[data-dc-recap-company]": 'input[name="properties[company]"]',
      "[data-dc-recap-title]": 'input[name="properties[job_title]"]'
    };
    Object.keys(map).forEach(function (target) {
      var targetEl = form.querySelector(target);
      var sourceEl = form.querySelector(map[target]);
      if (targetEl && sourceEl) targetEl.textContent = sourceEl.value || "—";
    });
    var cvFallback = form.querySelector("[data-dc-cv-fallback]");
    var cvUrlInput = form.querySelector("[data-dc-cv-url-target]");
    var cvRecap = form.querySelector("[data-dc-recap-cv]");
    if (cvRecap) {
      if (cvUrlInput && cvUrlInput.value.trim()) {
        cvRecap.textContent = "Reçu ✓";
      } else if (cvFallback && cvFallback.files.length) {
        cvRecap.textContent = cvFallback.files[0].name;
      } else {
        cvRecap.textContent = "—";
      }
    }
  }

  /* ---------------- Upload box UX (fallback natif) ---------------- */
  var uploadBox = form.querySelector("[data-dc-upload-box]");
  var uploadInput = form.querySelector("[data-dc-cv-fallback]");
  if (uploadBox && uploadInput) {
    uploadBox.addEventListener("click", function () { uploadInput.click(); });
    uploadInput.addEventListener("change", function () {
      if (uploadInput.files && uploadInput.files.length) {
        uploadBox.classList.add("dc-upload--filled");
        var title = uploadBox.querySelector("[data-dc-upload-title]");
        if (title) title.textContent = uploadInput.files[0].name;
        dcTrack("cv_uploaded", { method: "fallback_input" });
      }
    });
  }

  /* ---------------- Submit : ajoute le Pack Décroche au panier ---------------- */
  var submitBtn = form.querySelector("[data-dc-submit]");
  if (submitBtn) {
    submitBtn.addEventListener("click", function (e) {
      e.preventDefault();
      if (!validateStep(currentStep)) return;
      submitBtn.disabled = true;
      submitBtn.textContent = "Préparation…";

      var properties = {};
      form.querySelectorAll('[name^="properties["]').forEach(function (field) {
        var key = field.name.match(/properties\[(.+)\]/)[1];
        if (field.type === "radio") {
          if (field.checked) properties[key] = field.value;
        } else if (field.type === "checkbox") {
          properties[key] = field.checked ? "Oui" : "Non";
        } else {
          properties[key] = field.value;
        }
      });

      // Le nom du fichier de secours est transmis comme référence textuelle ;
      // le fichier lui-même doit être hébergé par l'app d'upload native
      // (voir README-DECROCHE.md) pour être exploitable par l'automatisation.
      if (uploadInput && uploadInput.files && uploadInput.files.length && !properties.cv_file_url) {
        properties.cv_filename_fallback = uploadInput.files[0].name;
      }

      dcTrack("checkout_started", {});

      fetch(cartAddUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1, properties: properties }]
        })
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw err; });
          return res.json();
        })
        .then(function () {
          window.location.href = cartUrl;
        })
        .catch(function (err) {
          submitBtn.disabled = false;
          submitBtn.textContent = "Préparer ma candidature — 29,90 €";
          var globalError = form.querySelector("[data-dc-global-error]");
          if (globalError) {
            globalError.textContent = (err && err.description) || "Une erreur est survenue. Réessaie dans un instant.";
            globalError.classList.add("dc-error--visible");
          }
        });
    });
  }

  showStep(0);
})();

/**
 * DÉCROCHE v2 — révélations au scroll, mockups animés, onglets, explorateur
 * de pack, effet machine à écrire. Comportements additifs, indépendants du
 * wizard ci-dessus : chaque bloc vérifie la présence de ses éléments avant
 * d'agir, donc ce script ne fait rien sur les pages qui n'utilisent pas ces
 * composants.
 */
(function () {
  "use strict";

  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------------- Reveal on scroll ---------------- */
  var rvEls = document.querySelectorAll(".dc-rv");
  if (rvEls.length) {
    if ("IntersectionObserver" in window && !reduced) {
      var rvIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-in");
            rvIo.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });
      rvEls.forEach(function (el) { rvIo.observe(el); });
    } else {
      rvEls.forEach(function (el) { el.classList.add("is-in"); });
    }
  }

  /* ---------------- Mock score card (hero) ---------------- */
  document.querySelectorAll("[data-dc-mock-card]").forEach(function (card) {
    var scoreEl = card.querySelector("[data-dc-mock-score]");
    var target = parseInt(card.getAttribute("data-dc-mock-target") || "78", 10);
    function countUp() {
      card.classList.add("is-live");
      if (reduced || !scoreEl) {
        if (scoreEl) scoreEl.textContent = target;
        return;
      }
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / 900, 1);
        scoreEl.textContent = Math.round(p * target);
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if ("IntersectionObserver" in window) {
      var mIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { countUp(); mIo.disconnect(); }
        });
      }, { threshold: 0.4 });
      mIo.observe(card);
    } else {
      countUp();
    }
  });

  /* ---------------- Segmented tab switcher ---------------- */
  document.querySelectorAll("[data-dc-tab-group]").forEach(function (group) {
    var tabs = group.querySelectorAll(".dc-tab");
    var thumb = group.querySelector(".dc-tabs-thumb");
    var panes = group.querySelectorAll("[data-dc-tab-pane]");
    tabs.forEach(function (tab, idx) {
      tab.addEventListener("click", function () {
        tabs.forEach(function (t) { t.classList.remove("is-active"); t.setAttribute("aria-selected", "false"); });
        tab.classList.add("is-active");
        tab.setAttribute("aria-selected", "true");
        if (thumb) thumb.style.transform = "translateX(" + idx * 100 + "%)";
        var targetKey = tab.getAttribute("data-dc-tab-target");
        panes.forEach(function (pane) {
          var show = pane.getAttribute("data-dc-tab-pane") === targetKey;
          if (reduced) {
            pane.style.display = show ? "block" : "none";
            return;
          }
          if (show) {
            pane.style.opacity = "0";
            pane.style.display = "block";
            requestAnimationFrame(function () { pane.style.opacity = "1"; });
          } else {
            pane.style.display = "none";
          }
        });
      });
    });
  });

  /* ---------------- Pack explorer ---------------- */
  document.querySelectorAll(".dc-pack-explorer").forEach(function (explorer) {
    var items = explorer.querySelectorAll("[data-dc-pack-target]");
    var panels = explorer.querySelectorAll("[data-dc-pack-pane]");
    items.forEach(function (item) {
      item.addEventListener("click", function () {
        items.forEach(function (i) { i.classList.remove("is-active"); i.setAttribute("aria-selected", "false"); });
        item.classList.add("is-active");
        item.setAttribute("aria-selected", "true");
        var targetKey = item.getAttribute("data-dc-pack-target");
        panels.forEach(function (panel) {
          panel.classList.toggle("is-active", panel.getAttribute("data-dc-pack-pane") === targetKey);
        });
      });
    });
  });

  /* ---------------- Typing effect (lettre de motivation) ---------------- */
  document.querySelectorAll("[data-dc-type-card]").forEach(function (card) {
    var textEl = card.querySelector("[data-dc-type-text]");
    if (!textEl) return;
    var fullText = card.getAttribute("data-dc-type-full") || "";
    var typed = false;
    function typeIt() {
      if (typed) return;
      typed = true;
      if (reduced || !fullText) {
        textEl.textContent = fullText;
        return;
      }
      var i = 0;
      var cursor = document.createElement("span");
      cursor.className = "dc-type-cursor";
      function step() {
        if (i <= fullText.length) {
          textEl.textContent = fullText.slice(0, i);
          textEl.appendChild(cursor);
          i++;
          setTimeout(step, 18);
        }
      }
      step();
    }
    if ("IntersectionObserver" in window) {
      var tIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { typeIt(); tIo.disconnect(); }
        });
      }, { threshold: 0.5 });
      tIo.observe(card);
    } else {
      typeIt();
    }
  });
})();
}
